import { Link, useLocation } from "react-router-dom";

export default function Header() {
  const { pathname } = useLocation();

  const navItems = [
    { href: "/om-os", label: "Om os" },
    { href: "/for-vikarer", label: "For vikarer" },
    { href: "/for-institutioner", label: "For institutioner" },
  ];

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-lg border-b border-slate-100">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-[4.5rem] md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center shrink-0" data-logo="true">
            <img
              src="/logo/logo_landscape.svg"
              alt="Plejesøstrene ApS – logo"
              className="h-10 sm:h-12 md:h-14 w-auto"
              decoding="async"
              loading="eager"
            />
          </Link>

          {/* Desktop navigation */}
          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
                  pathname === item.href
                    ? "text-brand-600 bg-brand-50"
                    : "text-slate-600 hover:text-slate-900 hover:bg-slate-50"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* CTA */}
          <Link to="/kontakt" className="btn btn-primary btn-sm">
            Kontakt os
          </Link>
        </div>
      </div>
    </header>
  );
}
